// Remove Files

attachEvent('.uploaded-files .delete-button', 'click', (ev) => {
  const item = ev.target.closest('.uploaded-files__item');
  if (item) item.remove();
});
